import { render, staticRenderFns } from "./MerchantIndex.vue?vue&type=template&id=a669492c&scoped=true"
import script from "./MerchantIndex.vue?vue&type=script&lang=js"
export * from "./MerchantIndex.vue?vue&type=script&lang=js"
import style0 from "./MerchantIndex.vue?vue&type=style&index=0&id=a669492c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a669492c",
  null
  
)

export default component.exports